import type { Cart } from '../hooks/use-cart'

export function getTouristTaxType(cart: Cart): 'CityTax' | 'SpaTax' | undefined {
  const accommodationItems = cart.items.accommodations

  const hasCityTax = accommodationItems.some(item => item.touristTax?.type === 'CityTaxExcluded')

  if (hasCityTax) return 'CityTax'

  const hasSpaTax = accommodationItems.some(item => item.touristTax?.type === 'SpaTaxExcluded')

  if (hasSpaTax) return 'SpaTax'

  return
}
